export const PLUGIN_NAME = 'auth-wsb-fe';
export const PROVIDER_KEY = 'blaze_auth_wsb';
export const PROVIDER_NAME = 'Blaze auth WSB';
export const EMAIL = 'email';
export const PASSWORD = 'password';
export const LOGIN_FORM = 'loginForm';
export const COOKIE_KEY = 'wsb_api_authorization';
//# sourceMappingURL=constants.js.map